import Layout from '../../Layout'
import DashboardTopSection from '../../components/Home/DashboardTopSection'
import DashboardOverview from '../../components/Home/DashboardOverview'
import BlockVoucherProduct from '../../components/Home/BlockVoucherProduct'
import BlockProductHighProfit from 'components/Home/BlockProductHighProfit'
import BclockProductPurchased from 'components/Home/BclockProductPurchased'
import JustForYouBlock from 'components/Home/JustForYouBlock'

export default function Dashboard() {
    return (
        <Layout>
            <DashboardTopSection />
            <DashboardOverview />
            <BlockVoucherProduct />
            <div>
                <div id="BLOCK_PRODUCT" event-block="BLOCK_PRODUCT" className="grid lg:!grid-cols-2 grid-cols-1 gap-4">
                    <BlockProductHighProfit />
                    <BclockProductPurchased />
                </div>
            </div>
            <div id="BLOCK_RECOMMEND" event-block="BLOCK_RECOMMEND" className="[&>section]:p-0 [&>section]:mt-0 rounded-[10px]">
                <section className="styles_container__tcm_S MuiBox-root css-yd8sa2 !p-0 !mt-0" id="just-for-you">
                    <div className="styles_wrapperTitle__0iTyg MuiBox-root css-1lekzkb">
                        <div className="MuiBox-root css-j0ozid">
                            <span
                                className='sm:!inline-block !hidden'
                                style={{
                                    boxSizing: "border-box",
                                    display: "inline-block",
                                    overflow: "hidden",
                                    width: "initial",
                                    height: "initial",
                                    background: "none",
                                    opacity: 1,
                                    border: 0,
                                    margin: 0,
                                    padding: 0,
                                    position: "relative",
                                    maxWidth: "100%",
                                }}
                            >
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "block",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        maxWidth: "100%",
                                    }}
                                >
                                    <img
                                        alt=""
                                        aria-hidden="true"
                                        src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2753%27%20height=%2740%27/%3e"
                                        style={{
                                            display: "block",
                                            maxWidth: "100%",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                        }}
                                    />
                                </span>

                                <img
                                    data-origin-url="https://cdn-web-next.thuocsi.vn/images/iconV2/Hand1.png"
                                    src="https://cdn-web-next.thuocsi.vn/images/iconV2/Hand1.png"
                                    decoding="async"
                                    data-nimg="intrinsic"
                                    style={{
                                        position: "absolute",
                                        inset: 0,
                                        boxSizing: "border-box",
                                        padding: 0,
                                        border: "none",
                                        margin: "auto",
                                        display: "block",
                                        width: 0,
                                        height: 0,
                                        minWidth: "100%",
                                        maxWidth: "100%",
                                        minHeight: "100%",
                                        maxHeight: "100%",
                                    }}
                                />
                                <noscript />
                            </span>

                            <h2 className="styles_sectionHeader__IJC9w">
                                Dành riêng cho bạn
                            </h2>
                        </div>

                        <a
                            className="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiTypography-colorPrimary"
                            href="/product/just-for-you"
                        >
                            <div className="MuiBox-root css-axw7ok">
                                <span className="styles_viewmore__xWSnO">
                                    Xem tất cả
                                </span>

                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                >
                                    <path
                                        d="M16.006 11.0818C16.5418 11.5767 16.5418 12.4233 16.006 12.9182L11.5982 16.99C10.7976 17.7295 9.5 17.1617 9.5 16.0718V7.9282C9.5 6.83829 10.7976 6.27045 11.5982 7.01001L16.006 11.0818Z"
                                        fill="#005C29"
                                    />
                                    <rect
                                        x="0.5"
                                        y="0.5"
                                        width="23"
                                        height="23"
                                        rx="11.5"
                                        stroke="#005C29"
                                    />
                                </svg>
                            </div>
                        </a>
                    </div>
                    <JustForYouBlock />
                </section>
            </div>
        </Layout>
    )
}
